import React from "react";
import {
  Box,
  Container,
  Grid,
  Typography,
  Link,
  useTheme,
  IconButton,
  Stack,
  Divider,
  alpha,
} from "@mui/material";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder"; // Ícone do logo
import TwitterIcon from "@mui/icons-material/Twitter";
import InstagramIcon from "@mui/icons-material/Instagram";
import FacebookIcon from "@mui/icons-material/Facebook";
import LocalHospitalIcon from "@mui/icons-material/LocalHospital"; // Ícone para link

export const Footer = () => {
  const theme = useTheme();
  const currentYear = new Date().getFullYear();

  const socialLinks = [
    { icon: FacebookIcon, label: "facebook", href: "#" },
    { icon: InstagramIcon, label: "instagram", href: "#" },
    { icon: TwitterIcon, label: "twitter", href: "#" },
  ];

  const navLinks = [
    { label: "Sobre Nós", href: "#" },
    { label: "Planos", href: "#nossos-planos" },
    { label: "Benefícios", href: "#beneficios" },
    { label: "FAQ", href: "#" },
    { label: "Contato", href: "#formulario" },
  ];

  const legalLinks = [
    { label: "Política de Privacidade", href: "#" },
    { label: "Termos de Uso", href: "#" },
  ];

  return (
    <Box
      id="contato" // Adicionado ID para navegação
      component="footer"
      sx={{
        backgroundColor: alpha(theme.palette.primary.light, 0.15),
        borderTop: `1px solid ${theme.palette.divider}`,
        color: theme.palette.text.secondary,
        py: { xs: 6, md: 8 },
        mt: "auto", // Empurra o footer para o fim da página
      }}
    >
      <Container maxWidth="lg">
        <Grid
          container
          spacing={4}
          sx={{ mb: 4 }}
          justifyContent="space-between"
        >
          {/* Coluna 1: Logo e Descrição */}
          <Grid item xs={12} md={4}>
            <Box
              sx={{ display: "flex", alignItems: "center", gap: 0.8, mb: 2 }}
            >
              <FavoriteBorderIcon
                sx={{ color: theme.palette.secondary.main, fontSize: 28 }}
              />
              <Typography
                variant="h6"
                sx={{ fontWeight: 700, color: theme.palette.text.primary }}
              >
                Plano Carinho
              </Typography>
            </Box>
            <Typography variant="body2" sx={{ mb: 3, maxWidth: 350 }}>
              Cuidando da sua saúde com a atenção e o carinho que você merece.
              Planos completos para toda a família.
            </Typography>
            <Stack direction="row" spacing={1}>
              {socialLinks.map((link) => (
                <IconButton
                  key={link.label}
                  aria-label={link.label}
                  href={link.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  size="small"
                  sx={{
                    color: theme.palette.text.secondary,
                    backgroundColor: alpha(theme.palette.primary.main, 0.1),
                    "&:hover": {
                      color: theme.palette.primary.contrastText,
                      backgroundColor: theme.palette.primary.main,
                    },
                  }}
                >
                  <link.icon fontSize="inherit" />
                </IconButton>
              ))}
            </Stack>
          </Grid>

          {/* Coluna 2: Navegação */}
          <Grid item xs={6} sm={4} md={2.5}>
            <Typography
              variant="subtitle1"
              sx={{ fontWeight: 600, color: theme.palette.text.primary, mb: 2 }}
            >
              Navegue
            </Typography>
            <Stack spacing={1}>
              {navLinks.map((link) => (
                <Link
                  key={link.label}
                  href={link.href}
                  underline="hover"
                  variant="body2"
                  sx={{
                    color: theme.palette.text.secondary,
                    "&:hover": { color: theme.palette.secondary.dark },
                  }}
                >
                  {link.label}
                </Link>
              ))}
            </Stack>
          </Grid>

          {/* Coluna 3: Legal */}
          <Grid item xs={6} sm={4} md={2.5}>
            <Typography
              variant="subtitle1"
              sx={{ fontWeight: 600, color: theme.palette.text.primary, mb: 2 }}
            >
              Informações
            </Typography>
            <Stack spacing={1}>
              {legalLinks.map((link) => (
                <Link
                  key={link.label}
                  href={link.href}
                  underline="hover"
                  variant="body2"
                  sx={{
                    color: theme.palette.text.secondary,
                    "&:hover": { color: theme.palette.secondary.dark },
                  }}
                >
                  {link.label}
                </Link>
              ))}
              {/* Exemplo de link externo */}
              <Link
                href="https://www.ans.gov.br/"
                target="_blank"
                rel="noopener noreferrer"
                underline="hover"
                variant="body2"
                sx={{
                  color: theme.palette.text.secondary,
                  "&:hover": { color: theme.palette.secondary.dark },
                  display: "flex",
                  alignItems: "center",
                  gap: 0.5,
                }}
              >
                <LocalHospitalIcon fontSize="inherit" /> ANS
              </Link>
            </Stack>
          </Grid>
        </Grid>

        <Divider sx={{ borderColor: alpha(theme.palette.primary.dark, 0.2) }} />

        <Box
          sx={{
            pt: 3,
            textAlign: "center",
          }}
        >
          <Typography variant="caption" display="block">
            © {currentYear} Plano Carinho. Todos os direitos reservados.
          </Typography>
          <Typography variant="caption" display="block">
            CNPJ: XX.XXX.XXX/0001-XX | Registro ANS nº XXXXXX-X
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};
